module.exports = __webpack_public_path__ + "static/media/earnedInADay_7500_10000.fbfb8deb.png";